import { useQuery } from "@tanstack/react-query";
import { Waves, Search, CheckCircle2, Fence, Baby, CalendarCheck, Users, HeartPulse, Handshake, Building2, Map, DollarSign } from "lucide-react";
import { api, num, money } from "@/lib/api";

export const useImpact = () => useQuery({ queryKey: ["impact"], queryFn: () => api.get("/impact").then((r) => r.data) });

const ITEMS = [
  ["ponds_reported", "Ponds Reported", Map],
  ["ponds_assessed", "Ponds Assessed", Search],
  ["ponds_completed", "Ponds Completed", CheckCircle2],
  ["fence_feet", "Feet of Fence Installed", Fence],
  ["children_sponsored", "Children Sponsored", Baby],
  ["sessions_funded", "Swim Sessions Funded", Waves],
  ["families_educated", "Families Educated", Users],
  ["cpr_participants", "CPR Participants", HeartPulse],
  ["community_partners", "Community Partners", Handshake],
  ["corporate_sponsors", "Corporate Sponsors", Building2],
];

export default function ImpactGrid({ extended = false }) {
  const { data } = useImpact();
  const items = extended ? [...ITEMS, ["total_raised", "Raised Through the PWA", DollarSign], ["kid_promises", "Kids' Promises Made", CalendarCheck]] : ITEMS;
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {items.map(([k, label, Icon]) => (
          <div key={k} className="rounded-2xl bg-white border border-sky-100 p-4 md:p-5 card-lift" data-testid={`impact-${k}`}>
            <Icon className="w-6 h-6 text-[#0096C7]" />
            <p className="font-display text-3xl md:text-4xl font-bold text-[#03045E] mt-3">{data ? (k === "total_raised" ? money(data[k]) : num(data[k])) : "—"}</p>
            <p className="text-xs uppercase tracking-wider font-bold text-slate-500 mt-1">{label}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-500 mt-4" data-testid="impact-note">Every number above is counted live from Swim for Rakim program records. Children are counted in aggregate only — no personal information is ever shown publicly.</p>
    </div>
  );
}
